/**
 * 路线配置实体
 * zxw
 * 2024-09-19
 */
import React, { Component } from 'react';
import { Modal, Input,Row,Col, Button,
    message,
    InputNumber, } from 'antd';
import $ from 'jquery';
import { AddRequestHeaders } from '../../incs/FunHelper';
import CNF from '../../incs/Config';

const MODULENAME = '路线';

const { TextArea } = Input;

class Entity extends Component{
    constructor(props){
        super(props);
        this.state = {
            loading: false,
            ulid: '',
            number: 0,
            name: '',
            useSN: 1,
            description: '',
        }
    }

    changeNumber = (value) =>{this.setState({number: value});}
    changeName = (e) =>{this.setState({name: e.target.value});}
    changeUseSN = (value) =>{this.setState({useSN: value});}
    changeDescription = (e) =>{this.setState({description: e.target.value});}

    update = () =>{
        const _this = this;

        //  执行更新
        $.ajax({
            url: `${CNF.api}lines/${this.state.ulid}`,
            headers: AddRequestHeaders(),
            type: 'PUT',
            dataType: 'JSON',
            data:JSON.stringify({
                'action': 'UPDATE',
                'number': this.state.number,
                'name': this.state.name,
                'use_sn': this.state.useSN,
                'description': this.state.description,
            }),success:function(data){
                if(data.res === 0){
                    message.success(data.msg, 1);
                    setTimeout(function(){
                        _this.handleCancel();
                        _this.props.isRefresh();
                    }, 1500);
                }else{
                    message.error(data.msg, 1.5);
                    _this.setState({loading: false});
                }
            }
        });
    };

    handleOk = () =>{
        //  参数校验
        //  路线编码
        if(this.state.number <= 0){
            message.error('路线编码格式错误！');
            return;
        }
        //  区域名称
        if(this.state.name === ''){
            message.error('区域名称不能为空！');
            return;
        }
        

        this.setState({loading: true});
        this.update();
    };
    
    handleCancel = () =>{
        this.props.setIsModalOpen(false);
        this.setState({
            loading: false,
            ulid: '',
            number: 0,
            name: '',
            useSN: 1,
            description: '',
        });
    };

    componentDidUpdate(){
        if (this.props.record && this.state.ulid !== this.props.record.key){
            this.setState({
                record: this.props.record,
                ulid: this.props.record.key,
                number: this.props.record.number,
                name: this.props.record.name,
                useSN: this.props.record.use_sn,
                description: this.props.record.description,
            });
        }
    }
  
    render() {
        return (
            <div>
                <Modal
                    width={500}
                    title={(this.props.record?'修改':'创建') + MODULENAME}
                    open={this.props.isModalOpen}
                    onCancel={this.handleCancel}
                    keyboard={true}
                    okText='确认'
                    cancelText='取消'
                    footer={[
                        <Button key="cancel" disabled={this.state.loading} onClick={this.handleCancel}>取消</Button>,
                        <Button key="ok" type="primary" disabled={this.state.loading} onClick={this.handleOk}>确定</Button>,
                      ]}
                    // style={{ top: 0 }}
                    okButtonProps={{ disabled: this.state.loading }}
                >
                    <Row style={{ marginTop: 5, lineHeight: 2.2 }}>
                        <Col span={5}>路线编号：</Col>
                        <Col span={19}>
                            <InputNumber
                                onChange={this.changeNumber}
                                placeholder='必填字段'
                                value={this.state.number}
                                disabled={this.state.loading}
                                min={1}
                                max={100}
                                step={1}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5, lineHeight: 2.2 }}>
                        <Col span={5}>使用序号：</Col>
                        <Col span={19}>
                            <InputNumber
                                onChange={this.changeUseSN}
                                placeholder='使用序号'
                                value={this.state.useSN}
                                disabled={this.state.loading}
                                min={this.state.useSN}
                                // max={100}
                                step={1}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5, lineHeight: 2.2 }}>
                        <Col span={5}>路线名称：</Col>
                        <Col span={19}>
                            <Input
                                onChange={this.changeName}
                                placeholder='必填字段'
                                value={this.state.name}
                                disabled={this.state.loading}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5 }}>
                        <Col span={5} style={{ lineHeight: 2.2 }}>备注：</Col>
                        <Col span={19}>
                            <TextArea
                                placeholder='备注可写在这里...'
                                autoSize={{ minRows: 2, maxRows: 4 }}
                                onChange={this.changeDescription}
                                disabled={this.state.loading}
                                value={this.state.description}
                            />
                        </Col>
                    </Row>
                </Modal>
            </div>
        );
    }
}

export default Entity